// Registers extra FontAwesome icons (from the same pro-light set llama uses) that
// aren't in llama's curated library, so the llama <Icon> can render them by name.
// Imported once in main.tsx.
import {
  library,
  type IconDefinition,
} from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUp,
  faArrowUpRightFromSquare,
  faBars,
  faCalculator,
  faCamera,
  faBell,
  faCircleCheck,
  faCircleExclamation,
  faClosedCaptioning,
  faCode,
  faComments,
  faCompress,
  faDiamond,
  faEllipsis,
  faEllipsisVertical,
  faEnvelopeOpen,
  faExpand,
  faEye,
  faEyeSlash,
  faFileLines,
  faHeart,
  faHouse,
  faIdCard,
  faLocationDot,
  faPause,
  faPencil,
  faPersonWalking,
  faPhone,
  faPlay,
  faPuzzlePiece,
  faRepeat,
  faShieldCheck,
  faSparkles,
  faSignalBars,
  faSquare,
  faSliders,
  faTrash,
  faVectorSquare,
  faWifi,
  faXmark,
} from '@fortawesome/pro-light-svg-icons';

// The filled pin, for the checklist card held at the top of the chat. Loft has
// only the light set as a dependency, so this is the solid set's definition
// copied in rather than importing pro-solid-svg-icons.
const faThumbtackSolid: IconDefinition = {
  prefix: 'fas',
  iconName: 'thumbtack',
  icon: [
    384,
    512,
    [],
    'f08d',
    'M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 10.3 134.1c37.1 21.2 65.8 56.4 78.2 99.7l3.8 13.4c2.8 9.7 .8 20-5.2 28.1S362 352 352 352L32 352c-10 0-19.5-4.7-25.5-12.7s-8-18.4-5.2-28.1L5 297.8c12.4-43.3 41-78.5 78.2-99.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 400l64 0 0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-112z',
  ],
};

library.add(
  faThumbtackSolid,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBars,
  faCalculator,
  faCamera,
  faBell,
  faCircleCheck,
  faCircleExclamation,
  faClosedCaptioning,
  faCode,
  faComments,
  faCompress,
  faDiamond,
  faEllipsis,
  faEllipsisVertical,
  faEnvelopeOpen,
  faExpand,
  faEye,
  faEyeSlash,
  faFileLines,
  faHeart,
  faHouse,
  faIdCard,
  faLocationDot,
  faPause,
  faPencil,
  faPersonWalking,
  faPhone,
  faPlay,
  faPuzzlePiece,
  faRepeat,
  faShieldCheck,
  faSparkles,
  faSquare,
  faSignalBars,
  faSliders,
  faTrash,
  faVectorSquare,
  faWifi,
  faXmark,
);
